module.exports = new __parcel__URL__("emit_above_planet_v4-1.27e631c8.png").toString();